import CashbacksDashboardContainer from './CashbacksDashboardContainer';

export default CashbacksDashboardContainer;
